import React from 'react';

import Conquest from '../conquest/conquest';
import { useTts } from '../conquest/tts/hooks/use-tts';
import Header from '../header/header';
import StudentProgress from '../student-progress/student-progress';
import css from './mle.scss';

const HeaderAndActivity = () => {
  const { readAloudConfig, onLocaleChange, onToggleEnableState } = useTts();
  return (
    <React.Fragment>
      <Header onLocaleChange={onLocaleChange} onToggleEnableState={onToggleEnableState} />
      <div className={css.content}>
        <Conquest readAloudConfig={readAloudConfig} />
        <StudentProgress />
      </div>
    </React.Fragment>
  );
};

export default HeaderAndActivity;
